export default {
  data() {
    return {
      dataFrom: {},
      dialogVisible: false
    };
  },
  computed: {
    dataRule() {
      return {
        property: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('财产保险累计收入')
        }],
        personal: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请填写') + this.$t('人身保险累计收入')
        }]
      };
    }
  },
  methods: {
    init() {
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          this.dataFrom.id = String(Math.random());
          this.dataFrom.organizationName = '泛华保险服务集团';
          this.dataFrom.total = Number(this.dataFrom.property) + Number(this.dataFrom.personal);
          this.$emit('cancel');
          this.$emit('ok', this.dataFrom);
        }
      });
    }
  }
};